import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { price } from 'utils/helpers';
import { getCurrentBooking } from 'redux/selectors/current_booking';

export function CartIcon({ isMobile = false }) {
  const booking = useSelector(getCurrentBooking);
  const balance = booking.balance_in_cents;

  if (!balance) {
    return null;
  }

  return isMobile ? (
    <a href="/cart">
      <span className="text-xxx-small mr-1">
        {price(balance)}
        <span className="sr-only"> - View my cart</span>
      </span>
      <i className="fas fa-shopping-cart" />
    </a>
  ) : (
    <div>
      <a className="header__top-button" href="/cart">
        <i
          className="icon__before-text fas fa-shopping-cart"
          aria-hidden="true"
        />
        Cart ({price(balance)})
      </a>
    </div>
  );
}

CartIcon.propTypes = {
  isMobile: PropTypes.bool,
};
